import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

import Login from "./pages/Login";
import ImageTable from "./pages/ImageTable";
import ApproveImages from "./pages/ApproveImages";
import PreApproveImages from "./pages/PreApproveImages";
import AssignKeywords from "./pages/AssignKeywords";
import Metrics from "./pages/Metrics";
import BooksData from "./pages/BooksData";
import Navbar from "./components/Navbar";
import PublicImages from "./pages/PublicImages";
import ImagesStatusMetrics from "./pages/ImagesStatusMetrics";
import GenerateImages from "./pages/GenerateImages";

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setUser(data?.session?.user ?? null);
      setAuthLoading(false);
    });
  }, []);

  async function handleLogout() {
    await supabase.auth.signOut();
    setUser(null);
  }

  const isAdmin = user?.app_metadata?.role === "admin";

  if (authLoading) {
    return <div className="container mt-4 text-center">Loading...</div>;
  }

  return (
    <Router>
      <div className="container mt-4">
        {user && <Navbar isAdmin={isAdmin} onLogout={handleLogout} />}

        <Routes>
          <Route path="/public_images" element={<PublicImages />} />

          <Route
            path="/"
            element={user ? <ImageTable /> : <Login onLogin={setUser} />}
          />

          {user && <Route path="/generate" element={<GenerateImages userEmail={user.email} />} />}
          {user && <Route path="/preapprove_images" element={<PreApproveImages />} />}
          {user && isAdmin && <Route path="/approve_images" element={<ApproveImages />} />}
          {user && <Route path="/assign_keywords" element={<AssignKeywords />} />}
          {user && isAdmin && <Route path="/metrics" element={<Metrics />} />}
          {user && <Route path="/books_data" element={<BooksData />} />}
          {user && <Route path="/images_metrics" element={<ImagesStatusMetrics />} />}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
